/* 거래소별 사용하는 코인 코드를 만들어 준다.
  * Rules: 
     - 업비트: 마켓(대문자)-코인심볼(대문자)
     - 코빗:  코인심볼(소문자)_마켓(소문자)
     - 빗썸:  코인심볼(대문자)_마켓(대문자)
*/

import { eventChannel, buffers } from 'redux-saga';

export const makerCoinCode = (coin: string): { [key: string]: string } => {
  coin = removePreSuffix(coin)
  return {
    upbit: `KRW-${coin.toUpperCase()}`,
    cobit: `${coin.toLowerCase()}_krw`,
    bithumb: `${coin.toUpperCase()}_KRW`,
    default: coin.toUpperCase()
  }
}

export const removePreSuffix = (coin: string): string => coin.replace('krw', '').replace('KRW', '').replace('-', '').replace('_', '')

export const makeStock = (
  code: string,
  name: string,
  timestamp: number = 0,
  open: string | number= '0',
  close: string | number= '0',
  volume: string | number= '0',
) => ({
  code: code,
  name: name,
  timestamp: timestamp,
  open: parseFloat(open.toString() || "0"),
  close: parseFloat(close.toString() || "0"),
  volume: parseFloat(volume.toString() || "0")
})

// WebSocket 객체생성
export const createSocket = (url: string, binaryType: string = "arraybuffer"): WebSocket => {
  const client: WebSocket  = new WebSocket(url);
  client.binaryType = "arraybuffer";

  return client
}

// WebSocket 연결
/*
  * @params
    - socket: 웹소켓 객체
    - payload: 소켓 연결 시 전달할 객체
    - onMsgHook(event): [isSave, data]
*/
export const connectSocekt = (socket: WebSocket, payload: any, onMsgHook: any, target?: string): any => {
  return eventChannel((emit) => {
    socket.onopen = () => {
      socket.send(payload);
    };

    socket.onmessage = (evt: {data: any}) => {
      let [isSave, data] = onMsgHook(evt)
      if (isSave) emit(data);
    };

    socket.onerror = (evt) => {
      emit(evt);
    };

    const unsubscribe = () => {
      socket.close();
    };

    return unsubscribe;
  }, buffers.expanding(500));
};
